import { createFileRoute } from "@tanstack/react-router";
import AdminContactsPage from "@/admin/pages/contacts";

export const Route = createFileRoute("/admin/contacts/")({
  component: AdminContactsPage,
});
